import React, { useContext } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import Signals from '../../../../signals/Signals';
import SchemaTriggerType from '../../../../data/SchemaTriggerType';
import SchemaTriggerIntervalValueType from '../../../../data/SchemaTriggerIntervalValueType';
import { ApplicationContext } from '../../../../ApplicationContext';
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
export default function AssetMetaData(props) {
    var serviceEntryModel = props.serviceEntryModel;
    var context = useContext(ApplicationContext);
    var serviceSchemaCollection = context.serviceSchemaCollection, assetCollection = context.assetCollection;
    var schemaModel = serviceSchemaCollection.findById(serviceEntryModel.schemaId);
    var assetModel = assetCollection.list.find(function (asset) { return asset.getAssetSerial() === serviceEntryModel.assetId; }); // We assume here that assets are retrieved already, and the assetModel is available
    return React.createElement("div", { className: "w-100" },
        serviceEntryModel.assignedTo &&
            React.createElement("span", null,
                React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.assignedto" }),
                ": ",
                serviceEntryModel.assignedTo,
                React.createElement("span", { className: "mx-2" }, "|")),
        serviceEntryModel.operatorName &&
            React.createElement("span", null,
                React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.operator" }),
                ": ",
                serviceEntryModel.operatorName,
                React.createElement("span", { className: "mx-2" }, "|")),
        serviceEntryModel.name &&
            React.createElement("span", null,
                React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.schema" }),
                ": ",
                schemaModel ? schemaModel.name : '-',
                React.createElement("span", { className: "mx-2" }, "|")),
        React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.asset" }),
        ":",
        React.createElement("span", { className: "btn-link cursor-pointer", onClick: function () {
                Signals.HideOverlay.dispatch();
                Signals.ShowAssetDetail.dispatch(assetModel);
            } },
            " ",
            assetModel ? assetModel.id : '-'),
        React.createElement("span", { className: "mx-2" }, "|"),
        React.createElement(FormattedMessage, { id: "page.assets.table.column.operatinghours" }),
        "\u00A0",
        React.createElement(FormattedNumber, { value: assetModel ? assetModel.cumulativeOperatingHoursDurationInHours : null, style: "unit", unit: "hour", minimumFractionDigits: 1, maximumFractionDigits: 1 }),
        React.createElement("span", { className: "mx-2" }, "|"),
        React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.triggertype" }),
        ": ",
        React.createElement(FormattedMessage, { id: 'service.schema.triggertype.' + SchemaTriggerType[serviceEntryModel.triggerType] }),
        React.createElement("span", { className: "mx-2" }, "|"),
        React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.triggerintervaltype" }),
        ": ",
        React.createElement(FormattedMessage, { id: 'service.schema.triggerintervaltype.' + SchemaTriggerIntervalValueType.getKeyByValue(serviceEntryModel.triggerIntervalValueType) }));
}
